import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('testimonials-slider')) {
  class TestimonialsSlider extends HTMLElement {
    selectors = {
      swiper: 'testimonials-slider .swiper',
      navigation: {
        prevEl: '.swiper-arrow-prev',
        nextEl: '.swiper-arrow-next',
      },
    };
    options = {
      slidesPerView: 1,
      loop: true,
      navigation: {
        ...this.selectors.navigation
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      on: {
        'realIndexChange': () => {
          this.onSlideChange();
        }
      }
    };
    slider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.slider = new Swiper(this.selectors.swiper, this.options);
    }

    onSlideChange() {
      this.querySelectorAll('[data-image-index]').forEach((image) => {
        image.classList.toggle('visible', Number(image.getAttribute('data-image-index')) === this.slider.realIndex);
      });
    }
  }
  customElements.define('testimonials-slider', TestimonialsSlider);
}
